import { Box } from '@opendoor/bricks-next';
import { PropertyDetailsFragment } from '__generated__/athena';
import { Divider } from 'components/shared/Divider';

import { HomeDetails } from '../HomeDetails';
import { PriceHistory } from '../PriceHistory';
import { Schools } from '../Schools';

interface PropertyDetailsProps {
  property: PropertyDetailsFragment;
}

export const PropertyDetails = ({ property }: PropertyDetailsProps) => {
  return (
    <>
      <Box tag="section">
        <HomeDetails property={property} />
        <Divider mt="$8x" mb="$8x" />
      </Box>
      <Box tag="section">
        <Schools schools={property?.schools} schoolDistricts={property?.schoolDistricts} />
        <Divider mt="$8x" mb="$8x" />
      </Box>
      <Box tag="section">
        {property?.listingHistory && <PriceHistory listingHistory={property.listingHistory} />}
        <Divider mt="$8x" mb="$20x" />
      </Box>
    </>
  );
};
